import EmptyProject from '../src/EmptyProject';
export default EmptyProject;
